import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-multi-select',
  standalone: true,
  imports:[FormsModule,CommonModule],
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss']
})
export class MultiSelectComponent {
  @Input() title: string = "";
  @Input() placeholdertext: string = "";
  filterBy: string = "";
  private _allItems: { [key: string]: any; } = [];  // Private variable to hold all items
  @Input() set availableItems(value: any) {
    this._allItems = value;

    // Selectable items are filtered all items
    this.selectableItems = value;
  }
  get availableItems(): any {
    return this._allItems;
  }
  @Input() selectedItems: { [key: string]: any; } = [];
  @Output() selectedItemsEvent = new EventEmitter<any>();

  selectableItems: { [key: string]: any; } = [];  
  selectableValues: string[] = [];

  filterItems(filterstring: string) {
    if (filterstring) {
      this.selectableItems = [];
      let allItems = this.getListValues(this.availableItems);
      
      allItems.forEach(value => {
        if (value.toLowerCase().includes((filterstring.toLowerCase()))) {
          let selectablekey = this.getKeyByValue(this.availableItems, value);          
          if (selectablekey.length > 0) {            
            Object.assign(this.selectableItems, { [selectablekey]: this.availableItems[selectablekey] });
          }          
        }
      });      
    } else {
      this.selectableItems = this.availableItems;
    }

    // Now remove any items from the filtered list which have already been selected.
    let selectedItems = this.getListValues(this.selectedItems);
    selectedItems.forEach(value => {
      let selectedkey = this.getKeyByValue(this.availableItems, value);
      if (selectedkey.length > 0) {        
        delete this.selectableItems[selectedkey];
      }
    });    
  }

  public getListValues(selectedList: { [key: string]: any; }): string[] {
    return Object.keys(selectedList).map(key => selectedList[key]);
  }

  public getKeyByValue(selectedList: { [key: string]: any; }, selectedValue: string): string {
    let returnKey = "";
    Object.keys(selectedList).forEach(key => {
      if (selectedList[key] == selectedValue) {
        returnKey = key;
      }
    })
    return returnKey;
  }

  moveSelected(item: string, direction: string) {
    if (direction === 'left') {
      this.moveItem(item, this.selectedItems, this.selectableItems, true);
    } else {
      this.moveItem(item, this.selectableItems, this.selectedItems, true);
    }
  }

  moveItem(selectedItem: string, from: { [key: string]: any; }, to: { [key: string]: any; }, notify: boolean) {

    let selectedkey = this.getKeyByValue(from, selectedItem);
    if (selectedkey.length > 0) {

      Object.assign(to, { [selectedkey]: from[selectedkey] });
      delete from[selectedkey];

      // If we move a Item then notify any listeners
      if (notify) {
        this.selectedItemsEvent.emit(this.selectedItems);
      }
    }
  }

  moveAll(direction: string) {
    if (direction === 'left') {
      this.getListValues(this.selectedItems).forEach(item => {
        this.moveItem(item, this.selectedItems, this.selectableItems, false);
      })      
    } else {
      this.getListValues(this.selectableItems).forEach(item => {
        this.moveItem(item, this.selectableItems, this.selectedItems, false);
      })      
    }

    // If we move Items then notify any listeners
    this.selectedItemsEvent.emit(this.selectedItems);
  }
  
}
